import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Sponsors from './Sponsors';
import Footer from './Footer';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#deecec',
    minHeight: '600px',
  },
}));

export default (props) => {
  const classes = useStyles();
  return (
  <>
    <div className={classes.container}>
      {props.children}
    </div>
    <Sponsors config={props.config} />
    <Footer />
  </>
  );
}
